/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.target = this.dataset.target;
        this.buttons = Array.from(this.querySelectorAll('button'));

        this.buttons.forEach((button) => {
          button.addEventListener('click', (event) => {

            let handle = button.dataset.collection;

            // remove active class from all buttons
            this.buttons.forEach(el => el.classList.remove('active'));

            // add active class to clicked tab
            button.classList.add('active');

            // change collection slider
            if (handle) this.toggleCollection(handle);

            event.preventDefault();
          });
        });

      }, 20);


      // Shopify editor support
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);
          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }


    // ----------------------------------------------
    // FIXED VERSION — NO WHITESPACE BUG
    // ----------------------------------------------
    toggleCollection(handle) {
      let slider = document.getElementById(this.target);
      let flkty = Flickity.data(slider);

      // Get all products
      let allProducts = Array.from(slider.querySelectorAll('.columns'));

      // Separate active/inactive
      let activeProducts = allProducts.filter(el => el.dataset.collection.includes(handle));
      let inactiveProducts = allProducts.filter(el => !el.dataset.collection.includes(handle));

      // 1. Remove all Flickity cells first
      flkty.remove(flkty.getCellElements());

      // 2. Remove slide classes
      allProducts.forEach(el => el.classList.remove('carousel__slide'));

      // 3. Add active products back as slides
      activeProducts.forEach(el => {
        el.classList.add('carousel__slide');
        slider.append(el);
      });

      // 4. Append inactive products behind slider
      inactiveProducts.forEach(el => slider.append(el));

      // 5. Insert only active products into Flickity
      flkty.insert(activeProducts);

      // 6. Recalculate slider properly
      flkty.reloadCells();
      flkty.resize();
      flkty.select(0, false, true);
    }

  }

  customElements.define('collection-tabs', CollectionTabs);
}
